import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  doubtTopics: {},
  questionList: {},
  commentList: {},
};

export const digitalDoubtReducer = createReducer(initialState, {
  [types.DOUBT_TOPIC_RESPONSE](state, action) {
    return {
      ...state,
      doubtTopics: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.FETCH_MEMBER_LIST_RESPONSE](state, action) {
    return {
      ...state,
      questionList: action.response.data,
      memberList: action.response.data.listMember,
      selfModel: action.response.data.selfModel,
      errorMessage: action.response.message,
    };
  },
  [types.INSERT_QUESTION_ITEM_RESPONSE](state, action) {
    let removeDuplicate = state.questionList.listQuestion.filter(
      item => item.QuestionID == action.response.QuestionID,
    );
    if (removeDuplicate.length == 0) {
      const listQuestion = [action.response,...state.questionList.listQuestion]
      let questionLisyt = {...state.questionList}
      questionLisyt.listQuestion= listQuestion
      return {
        ...state,
        questionList:questionLisyt,
        errorMessage: action.response.message,
      };
    }
  },

  [types.INSERT_STUDENT_COMMENT_ITEM_RESPONSE](state, action) {
    let removeDuplicate = state.commentList.listComment.filter(
      item => item.ActualID === action.response.ActualID
    );


    ///


    // if (removeDuplicate.length === 0) {
    //   const listCommenting = [...state.commentList.listComment,action.response]
    //   const commentListing = {...state.commentList}
    //   commentListing.listComment = listCommenting
    //   return {
    //     ...state,
    //     commentList:commentListing,
    //     errorMessage: action.response.message,
    //   };
    // } 
    
    ///



    var isReplaceCommentFromStateList = false;
    for(var i = 0; i < state.commentList.listComment.length; i++) {
      if(state.commentList.listComment[i].DFMID === action.response.DFMID && state.commentList.listComment[i].ActualID === "temp") {
        state.commentList.listComment[i] = action.response;
        isReplaceCommentFromStateList = true;
        break;
      }
    }

    ///
    

    if (removeDuplicate.length === 0) {
      var listCommenting;
      if(isReplaceCommentFromStateList) {
        listCommenting = [...state.commentList.listComment];
        isReplaceCommentFromStateList = false;
      } else {
        listCommenting = [...state.commentList.listComment, action.response];
      }
      
      const commentListing = { ...state.commentList };
      commentListing.listComment = listCommenting;
      return {
        ...state,
        commentList: commentListing,
        errorMessage: action.response.message,
      };
    }
    else {
      return {
        ...state,
        ...state.commentList,
        errorMessage: action.response.message,
      };
    }
  },

  [types.FETCH_QUESTION_LIST_RESPONSE](state, action) {
    return {
      ...state,
      questionList: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.FETCH_COMMENT_LIST_RESPONSE](state, action) {
    return {
      ...state,
      commentList: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
